import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '@utils/session.service';
import { ToastService } from '@utils/toast.service';

export function hasPermissionsGuard(allowedPermissions: string[] | null): CanActivateFn {
  return (route, state) => {
    const router = inject(Router);
    const session = inject(SessionService);
    const toastService = inject(ToastService);

    if (session.getRole() === 'SUPERUSER') {
      return true;
    }

    if (allowedPermissions === null || session.existsPermissions(allowedPermissions)) {
      return true;
    } else {
      router.navigate(['/']);
      toastService.error('No tienes permisos para acceder.');
      return false;
    }
  };
}
